import React from 'react';
import {
  LinearProgress,
  TableCell,
  TableHead,
  Table,
  TableContainer,
  Paper,
  TableRow,
  TableBody,
  TableFooter,
  TablePagination,
} from '@material-ui/core';
import LockIcon from '@mui/icons-material/Lock';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { Link } from 'react-router-dom';
import { Alert } from '@mui/material';

import TablePaginationActions from 'retired/TablePaginationActions';

import { BaseEntity, TableProps, EntityTypeFromUrl } from './types';

const dollarFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
});

const getEntityPath = (entityTypeFromUrl: EntityTypeFromUrl): string =>
  entityTypeFromUrl === 'teams' ? '/teams' : '/communities';

export const getEntityPathForApp = (entityTypeFromUrl: EntityTypeFromUrl): string =>
  entityTypeFromUrl === 'teams' ? '/team' : '/community';

export function EntityTable<T extends BaseEntity>({
  entities,
  entityTypeFromUrl,
  loading,
  page,
  rowsPerPage,
  totalCount,
  onPageChange,
  onRowsPerPageChange,
  clientUrl,
}: TableProps<T>): JSX.Element {
  if (loading) {
    return <LinearProgress />;
  }

  if (!entities) {
    return <Alert severity="error">An error occurred when fetching the {entityTypeFromUrl}</Alert>;
  }

  return (
    <TableContainer component={Paper}>
      <Table aria-label={`list of ${entityTypeFromUrl}`}>
        <TableHead>
          <TableRow>
            <TableCell>{entityTypeFromUrl === 'teams' ? 'Team Name' : 'Title'}</TableCell>
            <TableCell>Members</TableCell>
            <TableCell>Funds Donated</TableCell>
            <TableCell>Hours Volunteered</TableCell>
            <TableCell>Tagged Deeds</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>View in app</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {entities.map((entity) => (
            <TableRow key={entity.id}>
              <TableCell component="th" scope="row">
                <Link to={`${getEntityPath(entityTypeFromUrl)}/${entity.id}`}>
                  {entity.title}
                  {entity.isPrivate ? <LockIcon style={{ fontSize: 14, marginLeft: 12 }} /> : null}
                </Link>
              </TableCell>
              <TableCell style={{ color: '#979797' }}>{entity.membersCount}</TableCell>
              <TableCell style={{ color: '#979797' }}>
                {dollarFormatter.format(Math.round(entity.totalDonations))}
              </TableCell>
              <TableCell style={{ color: '#979797' }}>
                {Math.round(entity.totalVolunteering / 60)}
              </TableCell>
              <TableCell style={{ color: '#979797' }}>{entity._count?.Deeds}</TableCell>
              <TableCell component="th" scope="row">
                {entity.enabled === null || entity.enabled ? 'Active' : 'Inactive'}
              </TableCell>
              <TableCell>
                <a
                  href={`${clientUrl}${getEntityPathForApp(entityTypeFromUrl)}/${entity.id}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <ExitToAppIcon />
                </a>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
        {!!totalCount && (
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[5, 25]}
                colSpan={7}
                count={totalCount}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={(_event, newPage): void => onPageChange(newPage)}
                onChangePage={(_event, newPage): void => onPageChange(newPage)}
                onRowsPerPageChange={(event): void => {
                  onRowsPerPageChange(parseInt(event.target.value, 10));
                }}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter>
        )}
      </Table>
    </TableContainer>
  );
}
